import toastMessage from '@/components/Toast';

type AnyErr = unknown;

export function extractErrorMessage(error: AnyErr): string {
  if (!error) return 'Unknown error';
  if (typeof error === 'string') return error;

  const e: any = error;
  const res = e?.response;

  if (res) {
    const data = res.data;
    if (typeof data === 'string' && data) return data;
    if (typeof data?.error_msg === 'string' && data.error_msg)
      return data.error_msg;
    if (typeof data?.message === 'string' && data.message) return data.message;
    if (typeof data?.data === 'string' && data.data) return data.data;

    if (data && typeof data === 'object') {
      try {
        const firstKey = Object.keys(data)[0];
        const firstVal = (data as any)[firstKey];
        if (Array.isArray(firstVal) && firstVal.length) {
          const firstItem = firstVal[0];
          if (typeof firstItem === 'string') return firstItem;
          if (firstItem?.message) return String(firstItem.message);
        }
      } catch {}
    }

    if (res.statusText) return `${res.status} ${res.statusText}`;
  }

  if (e?.message) return String(e.message);

  try {
    return JSON.stringify(error);
  } catch {
    return 'Unexpected error';
  }
}

export function thunkError<RV extends string, F extends (value: RV) => any>(
  error: AnyErr,
  rejectWithValue: F,
  opts?: { toast?: boolean; prefix?: string },
): ReturnType<F> {
  const msg = extractErrorMessage(error);
  const finalMsg = opts?.prefix ? `${opts.prefix}: ${msg}` : msg;
  if (opts?.toast !== false) toastMessage.error(finalMsg);
  return rejectWithValue(finalMsg as RV);
}
